<template>
  <footer class="footer">
    <div class="container footer__inner">
      <div class="footer__grid">
        <section class="footer__col">
          <h3>Ubicación</h3>
          <p>
            <a :href="negocio.mapsUrl" target="_blank" rel="noopener noreferrer">{{ negocio.direccion }}</a>
          </p>
        </section>

        <section class="footer__col">
          <h3>Horario de atención</h3>
          <p><strong>Personal:</strong> abierto las 24 hs, todo el año.</p>
          <p><strong>Telefónica:</strong> lunes a viernes de 9 a 17 hs, sábados de 9 a 13 hs.</p>
        </section>

        <section class="footer__col">
          <h3>Contacto</h3>
          <p><a :href="telHref">{{ negocio.telefonoVisible }}</a></p>
          <p><a :href="mailHref">{{ negocio.email }}</a></p>
        </section>

        <section class="footer__col">
          <h3>Acerca de nosotros</h3>
          <p>
            En Cochera Belgrano, con más de 50 años de experiencia, ofrecemos estacionamiento seguro y de
            confianza en el corazón de la ciudad.
          </p>
        </section>
      </div>

      <p class="footer__copy">&copy; {{ year }} {{ negocio.razonSocial }}</p>
    </div>
  </footer>
</template>

<script>
import { NEGOCIO } from '../config';

export default {
  name: 'AppFooter',
  data() {
    return {
      negocio: NEGOCIO,
      // El año se actualiza solo
      year: new Date().getFullYear(),
    };
  },
  computed: {
    telHref() {
      return `tel:+${NEGOCIO.telefonoWhatsapp}`;
    },
    mailHref() {
      return `mailto:${NEGOCIO.email}`;
    },
  },
};
</script>

<style scoped>
.footer {
  background: var(--green);
  color: #ffffff;
}

.footer__inner {
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding-top: 48px;
  padding-bottom: 32px;
}

.footer__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 220px), 1fr));
  gap: 32px;
}

.footer__col {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.footer__col h3 {
  margin: 0 0 2px;
  font-family: var(--mono);
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--mint);
}

.footer__col p {
  margin: 0;
  font-size: 16px;
  line-height: 1.5;
  color: #e0f1e6;
  overflow-wrap: anywhere;
}

.footer__col strong {
  color: #ffffff;
}

.footer a {
  color: #e0f1e6;
  text-decoration: none;
}

.footer a:hover {
  color: #ffffff;
  text-decoration: underline;
}

.footer__copy {
  margin: 0;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.22);
  font-size: 14px;
  color: #a9cdb5;
}

/* Deja lugar abajo para que el botón flotante de WhatsApp no tape el texto */
@media (max-width: 640px) {
  .footer__inner {
    padding-bottom: calc(32px + 76px + env(safe-area-inset-bottom, 0px));
  }
}
</style>
